<template>
    <div>
        <el-table ref="table" :key="0" :data="tableData" style="width: 100%" v-if="_type == 'product'" v-loading="tabload">
            <el-table-column prop="id" label="编号ID" align="center" width="80px"> </el-table-column>
            <el-table-column prop="product_name" label="产品名称" align="center" width="200px">
                <template slot-scope="scope">
                    <el-tooltip v-if="scope.row.product_name && scope.row.product_name.length > 10" :content="scope.row.product_name" placement="top" effect="light">
                        <span>{{ scope.row.product_name | strFmt }}</span>
                    </el-tooltip>
                    <span v-else>{{ scope.row.product_name | strFmt }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="brand_name" label="品牌名称" align="center" width="200px"> </el-table-column>
            <el-table-column prop="category_name" label="商品分类" align="center" width="200px"> </el-table-column>
            <el-table-column prop="agency_name" label="经销商名称" align="center" width="200px"> </el-table-column>
            <el-table-column prop="type" label="产品名单类型" align="center" width="200px">
                <template slot-scope="scope">
                    {{ scope.row.type == 1 ? "普通授权" : scope.row.type == 2 ? "白名单" : "黑名单" }}
                </template>
            </el-table-column>
            <el-table-column prop="sale_price" label="价格" align="center" width="140px">
                <template slot-scope="scope">
                    <p v-show="scope.row.type == 3">-</p>
                    <p v-show="scope.row.type != 3">销售价：{{ scope.row.type == 1 ? scope.row.sale_price : scope.row.white_sale_price }}</p>
                    <p v-show="scope.row.type != 3">上限价：{{ scope.row.type == 1 ? scope.row.price_top : scope.row.white_price_top }}</p>
                    <p v-show="scope.row.type != 3">下限价：{{ scope.row.type == 1 ? scope.row.price_bottom : scope.row.white_price_bottom }}</p>
                </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" align="center" width="140px">
                <template slot-scope="scope">
                    {{ scope.row.status == 1 ? "正常" : scope.row.status == 2 ? "停权" : "禁售" }}
                </template>
            </el-table-column>
            <el-table-column prop="option" label="操作" align="center" fixed="right" width="160px">
                <template slot-scope="scope">
                    <div class="link">
                        <el-link type="primary" @click="operate(scope.row)" v-if="scope.row.status != 2">{{ scope.row.status == 1 ? "禁售" : "解封" }}</el-link>
                        <el-link type="primary" @click="detail(scope.row.id)">详情</el-link>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-table ref="table1" :key="1" :data="tableData" style="width: 100%" v-else v-loading="tabload">
            <el-table-column prop="id" label="编号ID" align="center" width="80px"> </el-table-column>
            <el-table-column prop="name" label="分类名称" align="center"></el-table-column>
            <el-table-column prop="level" label="分类层级" align="center"> </el-table-column>
            <el-table-column prop="parent_name" label="上级分类" align="center">
                <template slot-scope="scope">
                    <el-tooltip v-if="scope.row.parent_name && scope.row.parent_name.length > 10" :content="scope.row.parent_name" placement="top" effect="light">
                        <span>{{ scope.row.parent_name | strFmt }}</span>
                    </el-tooltip>
                    <span v-else>{{ scope.row.parent_name | strFmt }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="option" label="操作" align="center" fixed="right" width="240px">
                <template slot-scope="scope">
                    <div class="link">
                        <el-link v-if="scope.row.level < 3" type="primary" @click="showCreateOrEditDia(scope.row, 'create')">添加子级</el-link>
                        <el-link type="primary" @click="showCreateOrEditDia(scope.row, 'edit')">编辑</el-link>
                        <el-link type="primary" @click="deleteCategory(scope.row.id)">删除</el-link>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <div class="pageList">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-sizes="pageSizes"
                :page-size="size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                background
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    props: {
        _type: {
            type: String,
            default: "",
        },
        total: {
            type: Number,
            default: 0,
        },
        size: {
            type: Number,
            default: 10,
        },
        page: {
            type: Number,
            default: 1,
        },
        pageSizes: {
            type: Array,
            default: () => {
                return [10, 20, 30, 40];
            },
        },
        tableData: {
            type: Array,
            default: [],
        },
        tabload: {
            type: Boolean,
            default: false,
        },
    },
    filters: {
        strFmt(val) {
            if (val) {
                if (val.length > 10) {
                    return val.substring(0, 10) + "...";
                }
                return val;
            }
            return "-";
        },
    },
    methods: {
        deleteCategory(id) {
            this.$emit("deleteCategory", id);
        },
        showCreateOrEditDia(row, type_str) {
            this.$emit("showCreateOrEditDia", row, type_str);
        },
        detail(id) {
            this.$emit("detail", id);
        },
        operate(row) {
            this.$emit("operate", row);
        },
        handleSizeChange(val) {
            this.$emit("handleSizeChange", val);
        },
        handleCurrentChange(val) {
            this.$emit("handleCurrentChange", val);
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-table th {
    background: #fafafa;
    padding: 10px 0;
}
.link {
    a {
        margin: 0 12px;
    }
}
.pageList {
    text-align: right;
    margin-top: 20px;
}
// ::v-deep .el-table .cell {
//     height: 140px !important;
// }
</style>